// extracted by mini-css-extract-plugin
export default {"simpleHeaderCell":"simpleHeaderCell--YEd5Z4lmFk"};